import { handleTildedField } from '@/helpers/handleTildedField'
import { capitalizeTokens } from '@/helpers/capitalizeTokens'

type ProductOptionStandardizer = (option:{
  name: string,
  nameId: number,
  value: string,
  valueId: number,
}) => {
  name: string,
  nameId: number,
  value: string,
  valueId: number,
}

export const standardizeProductOption: ProductOptionStandardizer = ({
  name,
  value,
  nameId,
  valueId,
}) => ({
  name,
  value: capitalizeTokens(handleTildedField(value)),
  nameId,
  valueId,
})

export default standardizeProductOption
